import { getOrderStatus } from '../../entities/order/model.js'
import { matchesOrderSearch, summarizeOrders } from './searchStats.js'
import { findWorkshopInterval, workshopOrderDate, workshopTimestamp } from './workshopIntervals.js'

export function filterWorkshopOrders(orders, { search = '', statuses = [], mechanics = [], masters = [], brands = [], min = '', max = '' } = {}) {
    return orders.filter(order =>
        (!statuses.length || statuses.includes(getOrderStatus(order))) &&
        (!mechanics.length || mechanics.includes(order.mechanic_name)) &&
        (!masters.length || masters.includes(order.master_name)) &&
        (!brands.length || brands.includes(order.car_brand)) &&
        (min === '' || (order.client_interest_score != null && Number(order.client_interest_score) >= Number(min))) &&
        (max === '' || (order.client_interest_score != null && Number(order.client_interest_score) <= Number(max))) &&
        matchesOrderSearch(order, search, ['car_brand', 'car_model', 'plate', 'client_name', 'mechanic_name', 'number', 'vin']))
}

const elapsed = (end, start) => {
    const a = workshopTimestamp(end), b = workshopTimestamp(start)
    return a && b ? (a - b) / 60000 : null
}
const average = values => values.length ? Math.floor(values.reduce((sum, n) => sum + n, 0) / values.length + 0.5) : null

export function summarizeWorkshop(orders, intervals = []) {
    const rows = [...new Map(orders.map(order => [order.id, order])).values()]
    const takes = [], works = [], staff = new Map()
    const buckets = intervals.map(interval => ({ ...interval, count: 0, takes: [], works: [] }))
    for (const order of rows) {
        // Preserve existing SQL formulas: creation -> assignment; assignment -> approval.
        const take = elapsed(order.in_progress_at, order.created_at)
        const work = order.outcome === 'approved' ? elapsed(order.approved_at, order.in_progress_at) : null
        if (take != null) takes.push(take)
        if (work != null) works.push(work)
        if (order.mechanic_id != null) {
            if (!staff.has(order.mechanic_id)) staff.set(order.mechanic_id, {
                id: order.mechanic_id, name: order.mechanic_name || 'Неизвестный механик',
                in_progress: 0, completed_today: 0, expired_today: 0, takes: [], works: [],
            })
            const person = staff.get(order.mechanic_id)
            if (order.status === 'in_progress') person.in_progress++
            if (order.outcome === 'approved') person.completed_today++
            if (['expired_open', 'expired_progress'].includes(order.outcome)) person.expired_today++
            if (take != null) person.takes.push(take)
            if (work != null) person.works.push(work)
        }
        const index = findWorkshopInterval(intervals, workshopOrderDate(order))
        if (index !== -1) {
            const bucket = buckets[index]
            bucket.count++
            if (take != null) bucket.takes.push(take)
            if (work != null) bucket.works.push(work)
        }
    }
    return {
        ...summarizeOrders(rows), avgTakeMinutes: average(takes), avgWorkMinutes: average(works),
        mechanicStats: [...staff.values()].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(({ takes, works, ...person }) => ({
            ...person, avg_take_minutes: average(takes), avg_work_minutes: average(works),
        })),
        dynamics: buckets.map(({ takes, works, ...bucket }) => ({
            ...bucket, avg_take: average(takes), avg_work: average(works),
        })),
    }
}
